module.exports = __webpack_public_path__ + "Rutan-Bold.ttf";